import {
	session,
	catchError
} from '@/js/util'
import {
	baseUrl
} from './env.js'

export default async (url = '', data = {}, type = 'GET', method = 'fetch') => {
	let token = session('token')
	if (token) {
		data.token = token
	}
	type = type.toUpperCase();

	if (window.Panduanxx(url) == 'json') {
		url = url.url
	} else {
		url = baseUrl + url;
	}


	if (type == 'GET') {
		if (url.indexOf('?') >= 0) {
			url += '&' + getUrlString(data)
		} else {
			url += '?' + getUrlString(data)
		}
	}
	if (type == 'POST') {
		if (url.indexOf('?') >= 0) {
			url += '&token=' + token
		} else {
			url += '?token=' + token
		}
	}
	if (type == 'IMAGE') {
		console.log(data, 'data')
		return uploadImage(url, data, token)
	}
	if (window.fetch && method == 'fetch') {
		let requestConfig = {
			//cookie既可以同域发送，也可以跨域发送
			//			credentials: 'include',
			method: type,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			mode: "cors",
			cache: "force-cache"
		}

		if (type == 'POST') {
			requestConfig.body = getUrlString(data)
		}
		try {
			let response = await fetch(url, requestConfig);
			return response.json();
		} catch (error) {
			throw new Error(error)
		}
	} else {
		return new Promise((resolve, reject) => {
			let requestObj;
			if (window.XMLHttpRequest) {
				requestObj = new XMLHttpRequest();
			} else {
				requestObj = new ActiveXObject;
			}

			let sendData = getUrlString(data);
			requestObj.open(type, url, true);
			requestObj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			requestObj.send(sendData);

			requestObj.onreadystatechange = () => {
				if (requestObj.readyState == 4) {
					if (requestObj.status == 200) {
						resolve(requestObj.response)
					} else {
						reject(requestObj)
					}
				}
			}
		})
	}
}

function getUrlString(data) {
	let dataArr = []; //数据拼接字符串
	if (Object.keys(data).length) {
		Object.keys(data).forEach(key => {
			if (data[key] || data[key] == 0) {
				dataArr.push(key + '=' + data[key])
			}
		})
	} else {
		return ''
	}
	return dataArr.join('&')
}

/** 
 * 使用fetch实现图片上传
 * @param {string} url  接口地址
 * @param {JSON} params body的请求参数
 * @return 返回Promise 
 */
function uploadImage(url, params, token) {

	console.log(params, 'params')

	return new Promise(function(resolve, reject) {
		let formData = new FormData();
		for (var key in params) {
			formData.append(key, params[key]);
		}
		let file = {
			uri: params.path,
			type: 'application/octet-stream',
			name: 'image.jpg'
		};
		formData.append("file", file);
		fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'multipart/form-data;charset=utf-8',
					"x-access-token": token,
				},
				body: formData,
			}).then((response) => response.json())
			.then((responseData) => {
				console.log('uploadImage', responseData);
				resolve(responseData);
			})
			.catch((err) => {
				console.log('err', err);
				reject(err);
			});
	});
}


// WEBPACK FOOTER //
// ./src/js/fetch.js